import { Fragment } from "react";
import { useUploadStore } from "../store/useUploadStore";

export function UploadResult() {
  const { response } = useUploadStore();

  if (!response) {
    return null;
  }

  const { summary, files } = response;

  return (
    <section className="results">
      <header>
        <h3>上传结果</h3>
        <p>
          {summary.message}（成功 {summary.succeeded} / 共 {summary.total}）
        </p>
      </header>
      <ul>
        {files.map((file, index) => (
          <Fragment key={`${file.originalFilename}-${index}`}>
            <li className={file.success ? "success" : "failure"}>
              <div>
                <strong>{file.originalFilename}</strong>
                {!file.success && file.reason && (
                  <span className="reason"> {file.reason}</span>
                )}
              </div>
              {file.success && (
                <small title="存储文件名">{file.storedFilename}</small>
              )}
            </li>
          </Fragment>
        ))}
      </ul>
    </section>
  );
}

